// eslint-disable-next-line no-restricted-imports
import { View } from 'dripsy';

export default View;
